import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';
import { MatFormField, MatLabel, MatError } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { GwallHintComponent } from '../gwall-hint/gwall-hint.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-dropdown-formly',
    templateUrl: './dropdown-formly.component.html',
    styleUrls: ['./dropdown-formly.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatError, GwallHintComponent, AsyncPipe, TranslatePipe]
})
export class DropdownFormlyComponent extends FieldType<FieldTypeConfig> {

}
